import React from 'react';

const TourUsers = {
  run: false,
  stepIndex: 0,
  steps: [
    {
      content: (
        <>
          <p>En esta sección podrás ver los usuarios de la plataforma</p>
          <p>Depende de tu rol, poidrás crear, ver o editat usuarios</p>
        </>
      ),
      placement: 'center',
      styles: {
        options: {
          width: 900,
        },
      },
      target: 'body',
      title: 'Gestión de usuarios',
    },
    {
      title: 'Puedes reiniciar el tour',
      content: (
        <div>
          <h3>Con este botón empieza de nuevo el tour</h3>
        </div>
      ),
      target: '.demo__segundo',
      placement: 'bottom',
    },
    {
      title: 'Este es el listado de usuarios disponible',
      content:
        'En este apartado podrás llevar a cabo acciones relacionadas con tus usuarios',
      target: '.RaList-main-43',
      placement: 'bottom',
    },
    {
      title: 'Cabecera de la tabla',
      content:
        'Haz click en alguno de los campos para ordenar de manera ascendente o descendente',
      target: '.RaDatagrid-headerRow-75',
      placement: 'bottom',
    },
    {
      title: 'Campo de búsqueda',
      content: 'Aquí podrás buscar por el nombre del cliente',
      target: '#q',
      placement: 'bottom',
    },
    {
      title: 'Crear',
      content: 'Aqui podrás crear un nuevo usuario',
      target:
        '.MuiButtonBase-root.MuiButton-root.MuiButton-text.RaButton-button-6.MuiButton-textPrimary.MuiButton-textSizeSmall.MuiButton-sizeSmall',
      placement: 'bottom',
    },
    {
      title: 'Exportar listado de usuarios',
      content: 'Aqui podrás esportyar en formato CSV el listado de usuarios',
      target: '[aria-label="Exportar"]',
      placement: 'bottom',
    },
  ],
};

export default TourUsers;
